// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getWeeklyPPC(projectId: string, companyId: string | null): Promise<Object> {
  const q: string = companyId !== null ? `?company_id=${companyId}` : '';
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/ppc_report${q}`);
}
